export default () => (
  /**
   * Ícone "checked" na cor azul
   */
  <svg
    width="11"
    height="9"
    viewBox="0 0 11 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.71149 8.79492C3.51508 8.79492 3.32605 8.71708 3.18652 8.57754L0.217424 5.60845C-0.0724745 5.31838 -0.0724745 4.84856 0.217424 4.55866C0.507493 4.26877 0.977311 4.26877 1.26721 4.55866L3.66802 6.95947L8.70145 1.05549C8.96746 0.743937 9.43573 0.706303 9.74797 0.972143C10.0599 1.23816 10.0972 1.70677 9.83131 2.01866L4.27634 8.53407C4.14196 8.69165 3.94795 8.78599 3.74088 8.79423C3.73108 8.79458 3.72129 8.79492 3.71149 8.79492Z"
      fill="#3C71DD"
    />
  </svg>
);
